import React from 'react';
import styles from './ThankYouAlert.module.css';
import SVG1 from '../constants/svg_1';
import SVG2 from '../constants/svg_2';

const ThankYouAlert = ({ onClose }) => {
    return (
        <div className={styles.thankYouContainer}>
            <div className={styles.thankYouModal}>
                <div className={styles.thankYouModalClose}>
                    <div onClick={() => onClose()}>
                        <SVG2 />
                    </div>

                </div>
                <SVG1 />
                <div style={{ maxWidth: 452,display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}} >
                    <h2>¡Muchas gracias por tu aportación!</h2>
                    <p style={{textAlign: 'center'}}>En breve, te enviaremos un correo con más información sobre tu donación.</p>

                </div>
            </div>
        </div>
    );
};

export default ThankYouAlert;